<template>
  <div class="scan-container">
    <a-page-header
      class="check-group-name"
      :title="lessonName"
      :sub-title="'课程ID:' + classTypeId"
      @back="back"
    >
      <template slot="title">
        {{ lessonName }}
      </template>
    </a-page-header>
    <div class="video-wrap">
      <VideoPlayer
        :ai-lesson-id="aiLessonId"
        :lesson-id="lessonId"
        :class-type-id="classTypeId"
        :companion-user-group-id="companionUserGroupId"
      />
    </div>
  </div>
</template>
<script>
import VideoPlayer from '@/components/VideoPlayer/index.vue'
export default {
  components: {
    VideoPlayer
  },
  data() {
    return {
      // ai讲次id
      aiLessonId: '',
      lessonId: '',
      // 班型id
      classTypeId: '',
      lessonName: '',
      companionUserGroupId: ''
    }
  },
  created() {
    const { groupId, lessonName, aiLessonId, lessonId, classTypeId } = this.$route.query
    this.aiLessonId = aiLessonId
    this.lessonId = lessonId
    this.classTypeId = classTypeId
    this.lessonName = lessonName
    this.companionUserGroupId = groupId
  },
  methods: {
    back() {
      this.$router.replace({
        name: 'classList'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.scan-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.check-group-name {
  padding: 5px;
  border-bottom: 1px solid #ebedf0;
  background: #fff;
}
.video-wrap {
  flex: 1;
  margin-bottom: 20px;
}
</style>